<template>
	<div class="guest-login">
		<div class="page-container">

			<div class="guest-login__box">
				<h1 class="guest-login__title">Guest Access</h1>
				<div v-if="error" class="guest-login__error" v-html="error"></div>
				<template v-else>
					<p>Loading your account...</p>
					<Loader></Loader>
				</template>
			</div>

		</div>
	</div>
</template>

<script>
import Loader from '../atoms/Loader'

export default {
	name: 'GuestLogin',
	components: {
		Loader,
	},
	data () {
		return {
			error: null,
		}
	},
	props: {
		token: String,		// From vue-router
	},
	created: function ()
	{
		this.$root.$data.appLoading = false;

		if(!this.token || this.token == '')
		{
			this.$router.push({name: 'Homepage'});
			return;
		}

		this.logUserIn();
	},
	beforeRouteLeave (to, from, next)
	{
		// Destroy the redirect (in case we navigated away but come back later and login)
		this.$root.$data.loginRedirect = null;
		next()
	},
	methods: {
		logUserIn: function()
		{
			var self = this;

			self.$api.guestLogin(self.token).then((success) =>
			{
				self.$root.getUser().then((success) =>
				{
					// Broadcast
					this.onLogin();
				})
				.catch((error) =>
				{
					this.onFailure(error);
				});
			})
			.catch((error) =>
			{
				this.onFailure(error);
			});
		},
		onLogin(success)
		{
			// Analytics
			this.trackEvent([
				'guest-user-login',
				'success',
				this.$root.$data.user ? this.$root.$data.user.id : null,
				0,
				false
			]);

			// Hotjar
			if (process.env.NODE_ENV === "production" && typeof hj == 'function')
			{
				hj('trigger', 'logged_in');
			}

			if(this.$root.$data.loginRedirect)
			{
				this.$router.push(this.$root.$data.loginRedirect);
			}
			else
			{
				this.$router.push({name: 'Homepage'});
			}
		},
		onFailure(error)
		{
			this.error = 'Your account has expired. Contact your IGT account manager to open a full account.'
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".guest-login";
	#{$c}
	{
		background-color: #F4F4F4;
		padding: { top: rem(192); bottom: rem(160); }
		text-align: center;

		&__box
		{
			max-width: 416px;
			@include extend(block-center);
			@include extend(bgc-pal--white);
			border: 1px solid palette('divider');
			border-radius: 4px;
			padding: rem(24) rem(48) rem(48);
			box-shadow: 0 4px 8px rgba(0,0,0,0.05);
		}

		&__title
		{
			@include extend(h3);
			margin-bottom: rem(24);
			color: palette('grey');
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/admin/GuestLogin.vue